import React from 'react';
import { default as NextLink } from 'next/link';

export const Link = ({ href, children, rest }: { href: string; children: React.ReactNode; rest?: any }) => (
  <NextLink href={href}>
    <a {...rest}>{children}</a>
  </NextLink>
);
